import type { ListenMode } from '@jabberr/core';
import { talkModeHint, talkModeLabel } from '../lib/plain.js';

/** Persistent participation mode, independent of the worker's hearing/thinking status. */
export function JabberrModeBadge({ mode }: { mode: ListenMode | null }) {
  if (!mode) return null;
  const label = talkModeLabel(mode);
  return <span className="room-avatar-mode" aria-label={`Jabberr mode: ${label}`} title={`${label}: ${talkModeHint(mode)}`}>{mode === 'mentions' ? 'Named' : label}</span>;
}
